import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import { useRef } from "react";

interface Props {
    value: number;
    onChange: (newValue: number) => void;
    disabled?: boolean;
    readOnly?: boolean;
    style?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
  }
  
  const InputMonetario: React.FC<Props> = (props : Props) => {
    const refValorUnitario = useRef<HTMLInputElement>(null);
  
    const formatarValor = (valor: number): string => {
      let texto = valor.toString();
      let decimais = texto.split('.')[1] || '';
      if (decimais.length > 2) {
        return (parseFloat(texto) * 10).toFixed(2);
      }
      return texto;
    };
  
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const { key } = e;
      const tamanhoTexto = refValorUnitario.current?.value.length || 0;
      const inicioSelecao = refValorUnitario.current?.selectionStart || 0;
  
      if (key === '0') {
        if (inicioSelecao > 3) {
          props.onChange(props.value * 10);
        }
        e.preventDefault();
      } else if (refValorUnitario.current && refValorUnitario.current.value === '') {
        refValorUnitario.current.value = 'R$ 0,00';
        e.preventDefault();
      } else if (key === 'Backspace') {
        if (tamanhoTexto === inicioSelecao + 1 || tamanhoTexto === inicioSelecao) {
          props.onChange(parseFloat((props.value / 10).toFixed(2)));
          moveCursorToEnd(refValorUnitario.current);
          e.preventDefault();
        }
      }
    };
  
    const handleChange = (e: InputNumberChangeEvent) => {
      const valor = e.value
      if (valor) {
        const valortext = formatarValor(valor);
        props.onChange(parseFloat(valortext));
        moveCursorToEnd(refValorUnitario.current);
      }
    };
  
    const moveCursorToEnd = (input: any) => {
      const length = input.value.length;
      input.setSelectionRange(length, length);
    };
  
    return (
      <InputNumber
        disabled={props.disabled}
        readOnly={props.readOnly}
        inputRef={refValorUnitario}
        value={props.value} // Format value before rendering
        useGrouping={false}
        onFocus={(e) => moveCursorToEnd(refValorUnitario.current)}
        locale="pt-BR"
        currency="BRL"
        mode="currency"
        minFractionDigits={2}
        maxFractionDigits={3}
        maxLength={10}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        inputStyle={{ ...props.inputStyle }}
        style={{ width: '100%', ...props.style }}
      />
    );
  };
  
  export default InputMonetario;
  